import OverflowMenu from "overflow-menu";

class OverflowMenuWrapper {
    constructor(
        overflowMenuContainer,
        overflowMenuSelector,
        overflowItem,
        overflowItemButton,
        overflowItemContainer
    ) {
        this.overflowMenuContainer = overflowMenuContainer;
        this.overflowMenuSelector = overflowMenuSelector;
        this.overflowItem = overflowItem;
        this.overflowItemButton = overflowItemButton;
        this.overflowItemContainer = overflowItemContainer;
    }

    initOverflowMenu() {
        const menu = new OverflowMenu.OverflowMenu({
            itemContainer: this.overflowMenuContainer,
            itemSelector: this.overflowMenuSelector,
            overflowItem: this.overflowItem,
            overflowContainer: this.overflowItemContainer
        });

        const monitor = new OverflowMenu.ResizeMonitor();

        monitor.onRecalculateSizes(() => {
            menu.refreshSizes();
            menu.refreshMenu();
        });

        monitor.onResize(() => {
            menu.refreshMenu();
        });

        monitor.start();
        menu.refreshMenu();

        window.addEventListener("DOMContentLoaded", () => {
            menu.refreshMenu();
        });

        setTimeout(() => {
            menu.refreshMenu();
        }, 500);
    }

    init() {
        this.initOverflowMenu();

        this.overflowItemButton.addEventListener("click", () => {
            this.overflowItem.classList.toggle("visible");
        });
    }
}

export default OverflowMenuWrapper;
